export default {

  headline: 'SIEGENIA Mediacenter',
  search_info: 'Co hledáte?',
  back: 'zpět',
  no_results: 'Nebyly nalezeny žádné výsledky. Zkontrolujte prosím hledaný dotaz.',
  service: {
    downloads: 'ke stažení',
    videos: 'videa',
    faq: 'FAQ'
  },

  service_search: {
    category_placeholder: "Filtrovat podle kategorie"
  },
  service_download: {
    select_info: 'Zvolte Vaši oblast vyhledávání',
    select_productgroup: 'Zvolte skupinu výrobků',
    select_product: 'Zvolte výrobek',
    select_type: 'Zvolte typ souboru',
    option_language: "Jazyk",

    types: {
      tec_info: 'Technické informace',
      installation: 'Návod na montáž',
      planning: 'Podklady pro projektování',
      catalog: 'Brožury',
      order_forms: 'Objednací formuláře',
      maintenance: 'Údržba, ovládání, péče',
      construction_drawings: 'Konstrukční výkresy',
      software: 'Software',
      certificate: 'Certifikáty a Pokyny',
      press: 'Tisk & Marketingové podklady',
      videos: 'Video',
      undefined: 'Ostatní',
      commercial: 'Reklamní podklady',
      product_video: 'Film o výrobku',
      operating: 'Ovládání',
      'function': 'Funkce',
      'assembly': 'Montáž',
      'installation_video': 'Instalace',
      'assembly_instructions': 'Návod na montáž',
      'brochure': 'Brožury',
      'tec_catalog': 'Technické katalogy',
      'tec_sheet': 'Technické listy',
      'usage_charts': 'Aplikační schémata',
      'profile_sheet': 'Profilové listy',
      'operations_manual': 'Návod k obsluze a péči',
      hardware_info: 'Informace o hardwaru',
      'installation_suggestion' : 'Montážní návod',
      'general' : 'Všeobecné',
      'troubleshooting' : 'Odstraňování problémů',
      "smarthome:general" : 'Všeobecné',
      'smarthome:installation' : 'instalace',
      'smarthome:troubleshooting' : 'Odstraňování problémů',
      'smarthome:startup' : 'Instalace',
      'smarthome:operating' : 'návod k použití',
      'order': 'Objednávka',
    },
    filter_sorting: {
      filter: "Filtr",
      sorting: "Třídění",
      asc: "Název Vzestupně (A-Z)",
      desc: "Název Sestupně (Z-A)",
      date_asc: "Datum nejstaršího prvního",
      date_desc: "Datum nejnovější první",
      relevance: "Důležitost",
      facet_headline: "Filtrovat výsledky vyhledávání",
      facet_filter_lang: "Jazyky",
      facet_filter_type_id: "Typ",
      facet_filter_level_0: "Kategorie",
      filter_remove: "Reset filtru",
      show_hide: "Zobrazit filtr",
    },
    result: {
      count_media: "Soubor",
      show_results: "Zobrazit",
      preview_type_catalog: "HTML",
      lang_not_available: "Aktuálně není k dispozici ve Vašem jazyku",
      version_info: "Tento odkaz vede na nejnovější verzi dokumentace. Pokud potřebujete starší verzi, obraťte se na svého zákaznického poradce společnosti SIEGENIA."
    }
  }

};
